export const REACT_APP_GOOGLE_MAPS_KEY =
  "AIzaSyB5kfuDY0Zyz-1V0FpgRI7zyAgncirzDxU";
  //"AIzaSyCl4alFc9wFZaQS7ywq6UIhA1eGuXISkE8";
export const REACT_APP_OPENWEATHERMAP_KEY =
  "9982cb0a3c24478117c2d51f8013dde4";